import { Link } from 'react-router-dom';
import './Footer.css';

export function Footer() {
  return (
    <footer className="footer">
      <div className="footer__content">
        <span className="footer__copyright">© 2026 LTRJ Labs LTD</span>
        <Link to="/terms" className="footer__link">
          Terms of Service
        </Link>
        <Link to="/privacy" className="footer__link">
          Privacy Policy
        </Link>
      </div>
    </footer>
  );
}

export default Footer;
